(function (ng) {
    ng.module('evo.Trip.Filters').filter('numeralCurrency', function () {
        return function (price) {
            return numeral(price).format();
        };
    });
})(angular);